import { P, TextArea } from '@workramp/ui';
import styled from 'styled-components';

export const AvatarInputWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  column-gap: ${({ theme }) => theme.spacing(2)}px;

  > &:first-child {
    flex-shrink: 0;
  }

  > &:last-child {
    flex: 1;
  }

  div[class^='StyledStack'] > &:nth-child(2) {
    display: none;
  }
`;

type WrapperProps = {
  $hideOnHover: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 ${({ theme }) => theme.spacing(2)}px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (min-width: 768px) {
    transform: translateX(100%);
  }

  ${({ $hideOnHover }) =>
    $hideOnHover &&
    `
      visibility: hidden;

      .task-object:hover & {
        transition: visibility 0s 500ms;
        visibility: visible;
      }`}
`;

export const InfoText = styled(P)`
  color: ${({ theme }) => theme.colors.on[600]};
`;

export const ButtonWrapper = styled.div`
  text-align: right;
`;

export const AvatarAndCloseButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
`;

export const VerticallyResizableTextarea = styled(TextArea)`
  textarea {
    resize: vertical;
  }
`;
